import { USCurrency } from 'components/ReusableComponents/FormattedPrice'

import styles from './BillableItems.module.scss'

const CustomChargeBillableItems = ({ customCharges }) => {
  if (!customCharges || customCharges.length === 0) return null

  const itemKinds = {
    Chargeback: 'Chargeback',
    PlatformServices: 'Professional services'
  }

  return (
    <div className={styles.billableItems}>
      <p className={styles.billableItemsTitle}>Custom charges</p>
      {customCharges.map((charge, index) => (
        <div key={index} className={styles.billableItem}>
          <div className={styles.billableItemText}>
            <p className={styles.billableItemTitle}>{itemKinds[charge.kind]}</p>
            <p className={styles.billableItemDescription}>{charge.description}</p>
          </div>
          <div className={styles.billableItemPrice}>
            <USCurrency withCode>{charge.amount}</USCurrency>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CustomChargeBillableItems
